module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-bottom-01.1.9cc1f2e0.jpg";